import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const CopyRight2 = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.39061 14.8846C6.42411 14.8846 5.64061 14.1011 5.64061 13.1346L5.64061 2.75C5.64061 1.7835 6.42411 1 7.39061 1L15.3521 1C16.3186 1 17.1021 1.7835 17.1021 2.75V13.1346C17.1021 14.1011 16.3186 14.8846 15.3521 14.8846L7.39061 14.8846ZM7.14061 13.1346C7.14061 13.2726 7.25254 13.3846 7.39061 13.3846L15.3521 13.3846C15.4902 13.3846 15.6021 13.2726 15.6021 13.1346L15.6021 2.75C15.6021 2.61193 15.4902 2.5 15.3521 2.5L7.39061 2.5C7.25254 2.5 7.14061 2.61193 7.14061 2.75L7.14061 13.1346ZM4.25 18.5768C3.00736 18.5768 2 17.5695 2 16.3268L2 6.42306C2 5.45656 2.7835 4.67306 3.75 4.67306L4.65985 4.67306V6.17306H3.75C3.61193 6.17306 3.5 6.28499 3.5 6.42306L3.5 16.3268C3.5 16.7411 3.83579 17.0768 4.25 17.0768H11.7751C11.9132 17.0768 12.0251 16.9649 12.0251 16.8268V15.8461H13.5251V16.8268C13.5251 17.7933 12.7416 18.5768 11.7751 18.5768H4.25Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default CopyRight2
